var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartVisibility)?_c('div',{staticClass:"rounded-lg pt-2"},[_c('highcharts',{ref:"funnel-3d-chart",staticClass:"chart-content_wrapper",attrs:{"options":_vm.chartOptions,"callback":_vm.onInitChartCallback,"updateArgs":[true, true]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }